import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const PageSize = ({
  tableManager,
  value = tableManager.paginationApi.pageSize,
  onChange = tableManager.paginationApi.setPageSize,
  options = tableManager.config.pageSizes
}) => {
  const {
    config: {
      texts: {
        rowsPerPage: rowsPerPageText
      },
      additionalProps: {
        pageSize: additionalProps = {}
      }
    }
  } = tableManager;
  let classNames = ('rgt-footer-page-size ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [/*#__PURE__*/_jsxs("span", {
      children: [rowsPerPageText, " "]
    }), /*#__PURE__*/_jsx("select", {
      className: "rgt-footer-page-size-select",
      value: value,
      onChange: event => {
        onChange(event.target.value);
      },
      children: options.map(option => /*#__PURE__*/_jsx("option", {
        value: option,
        children: option
      }, option))
    })]
  });
};

export default PageSize;